import React, { FC, useState, useEffect } from 'react'
import classnames from 'classnames'
import styles from './TalksFramework.module.scss'

export interface TalksFrameworkProps {
  sidebarNav?: React.JSX.Element
  actionNav?: React.JSX.Element
  sidePanelContent?: React.JSX.Element
  content?: React.JSX.Element
  isSidePanelOpen?: boolean
  menuItemSelected?: string
  presenterBar?: React.JSX.Element
  spotlightControls?: React.JSX.Element | boolean
  hidden?: boolean
  isWarningActive?: boolean
}

const TalksFramework: FC<TalksFrameworkProps> = props => {

  const [ showPresenterBar, setShowPresenterBar ] = useState(typeof props.presenterBar !== 'undefined')
  const compRef = React.createRef<HTMLDivElement>()
  const showSidebar = typeof props.sidebarNav !== 'undefined' && typeof props.sidePanelContent !== 'undefined'
  const showActions = typeof props.actionNav !== 'undefined'

  useEffect(() => {

    setShowPresenterBar(typeof props.presenterBar !== 'undefined')

  }, [ props.presenterBar ])

  if (!showSidebar && !showActions && typeof props.content === 'undefined') return null

  const { isSidePanelOpen = false, content = '', hidden = false, isWarningActive = false } = props

  const mainClasses = classnames(
    styles['Framework'], {
      [styles['Framework__hidden']]: hidden
    }
  )

  const mainContentClasses = classnames(
    styles['Framework__pushable'], {
      [styles['Framework--sidebar-open']]: isSidePanelOpen
    }
  )

  const sidebarContentClasses = classnames(
    styles['Framework__sidebar-content'], {
      [styles['Framework--show-shadow']]: isSidePanelOpen
    }
  )

  const pusherClasses = classnames(
    styles['Framework__pusher'],
    styles['Framework--show-shadow']
  )

  return <div
    className={mainClasses}
    ref={compRef}
    data-bdd='framework'
  >
    <div className={mainContentClasses} data-bdd='framework-pushable'>
      <div className={classnames(styles['Framework__pushable-container'], {[styles['Framework__active-warning']]: isWarningActive})}>
        {
          showPresenterBar &&
          <div
            className={styles['Framework__presenter-bar']}
            data-bdd='framework-presenter-bar'
          >
            { props.presenterBar }
          </div>
        }
        <div
          className={styles['Framework__main-content']}
          data-bdd='framework-main-content'
        >
          {content}
        </div>
        {
          props.spotlightControls &&
          <div
            className={styles['Framework__presenter-spotlight-controls']}
            data-bdd='framework-spotlight-controls'
          >
            {props.spotlightControls}
          </div>
        }
        {
          showActions &&
          <div
            className={styles['Framework__presenter-action-menu']}
            data-bdd='framework-action-menu'
          >
            {props.actionNav}
          </div>
        }
      </div>
    </div>
    {
      showSidebar &&
      <div
        className={pusherClasses}
        data-bdd='framework-pusher'
      >
        <nav
          className={styles['Framework__sidebar-nav']}
          data-bdd='framework-sidebar-nav'
        >
          {props.sidebarNav}
        </nav>
        <div
          className={sidebarContentClasses}
          data-bdd={`framework-sidebar-content${isSidePanelOpen ? '-open' : ''}`}
          tabIndex={-1}
        >
          {props.sidePanelContent}
        </div>
      </div>
    }
  </div>

}

export default TalksFramework
